import { render } from "./SectorAssetsList.vue?vue&type=template&id=dee62bf0&scoped=true"
import script from "./SectorAssetsList.vue?vue&type=script&lang=js"
export * from "./SectorAssetsList.vue?vue&type=script&lang=js"

import "./SectorAssetsList.vue?vue&type=style&index=0&id=dee62bf0&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dee62bf0"]])

export default __exports__